// Copyright © 2024 650 Industries.
'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { View } from 'react-native';
export default function GlassContainer(props) {
    return /*#__PURE__*/ _jsx(View, {
        ...props
    });
}

//# sourceMappingURL=GlassContainer.js.map
